module.exports = __webpack_public_path__ + "static/img/city-overlay-optimized.3d82085.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/city-overlay-optimized.png
// module id = 439
// module chunks = 1